import script from "./DisciplineFilterSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DisciplineFilterSelect.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__